import { ReactNode } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { CenterView } from "../style/common_style";
const pageBackground = (background: string) =>
  !background || ["white", "#fff", "#ffffff"].includes(background.toLowerCase())
    ? "var(--user-surface)" : background;

const Container = styled(CenterView)<{ $background: string; $customer: boolean }>`
  width: 100%;
  height: var(--browser-layout-height, 100dvh);
  font-family: var(--font-Pretendard-Regular);
  background-color: ${(props) => props.$customer ? "var(--user-canvas)" : pageBackground(props.$background)};
  color: var(--user-text);
  overflow: hidden;
  /* 드래그 금지 */
  user-select: none;
`;

const ScrollArea = styled.div<{ $isScroll: string }>`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow: scroll;
  overflow: ${(props) => (props.$isScroll === "none" ? "hidden" : "auto")};
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ConBox = styled.div<{ $isScroll: string; $background: string; $customer: boolean }>`
  width: 100%;
  min-height: 100%;
  height: ${(props) => props.$isScroll === "none" ? "100%" : "auto"};
  margin: auto;
  max-width: 500px;
  background-color: ${(props) => props.$customer ? pageBackground(props.$background) : "transparent"};
`;

interface Layout {
  children: ReactNode;
  background?: string;
  isScroll?: string;
}

const Layout_user = (props: Layout) => {
  const { children } = props;
  const { pathname } = useLocation();
  const customer = !/^\/(admin|broadcast)(?:[\/_]|$)/.test(pathname);
  const background = props.background || "";
  const isScroll = props.isScroll || "";
  return (
    <Container $background={background} $customer={customer}>
      <ScrollArea $isScroll={isScroll}>
        <ConBox data-customer-canvas={customer || undefined} $isScroll={isScroll} $background={background} $customer={customer}>{children}</ConBox>
      </ScrollArea>
    </Container>
  );
};

export default Layout_user;
